import { VueQueryPlugin, QueryClient, dehydrate, hydrate } from "@tanstack/vue-query";

export default defineNuxtPlugin((nuxt) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000, // 30s — données considérées fraîches
        gcTime: 5 * 60 * 1000, // 5min — garbage collection
        refetchOnWindowFocus: false,
      },
    },
  });

  nuxt.vueApp.use(VueQueryPlugin, { queryClient });

  // SSR hydration support
  if (import.meta.server) {
    nuxt.hooks.hook("app:rendered", () => {
      nuxt.payload["vue-query"] = dehydrate(queryClient);
    });
  }

  if (import.meta.client) {
    nuxt.hooks.hook("app:created", () => {
      hydrate(queryClient, nuxt.payload["vue-query"]);
    });
  }
});
